import { Component, OnInit, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { AuthService } from 'core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-session-expired',
  templateUrl: 'session-expired.component.html',
  styleUrls: ['session-expired.component.scss'],
})
export class SessionExpiredComponent implements OnInit {
  private readonly modalRef = inject(BsModalRef);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  public static isShown = false;

  ngOnInit(): void {
    SessionExpiredComponent.isShown = true;
    this.modalRef.onHidden?.subscribe((event) => this.onHideSessionExpirePopup(event));
  }

  public hideModal(): void {
    this.modalRef.hide();
  }

  public reLogin(): void {
    this.modalRef.hide();
    this.authService.clearAuthData();
    this.router.navigateByUrl('login');
  }

  onHideSessionExpirePopup(event: any): void {
    SessionExpiredComponent.isShown = false;
    if (event === 'backdrop-click') {
      this.authService.clearAuthData();
      this.router.navigate(['']);
      location.reload();
    }
  }
}
